"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_SET_IS_ROLE_LOADING = exports.USER_SET_ROLE = void 0;
const const_1 = require("../../const");
exports.USER_SET_ROLE = `${const_1.PREFIX_ENRICH}USER_SET_ROLE`;
exports.USER_SET_IS_ROLE_LOADING = `${const_1.PREFIX_ENRICH}USER_SET_ROLE_LOADING`;
